import React from 'react'
import { CardHighChartCP } from 'modules/reports/components/charts/card-chart/CardHighChartCP'
import { HighChartsUtils } from 'modules/reports/components/charts/card-chart/inner/HighChartsUtils'
import { formatApprovedPercentage } from 'modules/reports/screens/screen-charts/content/qaqc/inner/QAQCDashboardUtils'
import { ThemeProject } from 'config/theme/project/ThemeProject'

interface ICPProps {
	cardTitle: string
	approved: number
	rejected: number
}

/**
 * Gráfico donut de amostras aprovadas/reprovadas com percentual centralizado.
 */
export function QAQCApprovalDonutChartCP(props: ICPProps): JSX.Element {

	const approved = props.approved ?? 0
	const rejected = props.rejected ?? 0
	const approvedPercentageLabel = formatApprovedPercentage(approved, rejected)

	return (
		<CardHighChartCP
			cardTitle={props.cardTitle}
			buttonsToHide={['linearScale', 'chartType', 'fixedRatioSize', 'showLabels']}
			chartOptions={{
				chart: {
					...HighChartsUtils.getChart('pie'),
					events: {
						render: function () {
							const chart = this
							const series = chart.series[0]
							if (!series?.center) return

							const x = series.center[0] + chart.plotLeft
							const y = series.center[1] + chart.plotTop + 6

							let label = (chart as any).centerLabel
							if (!label) {
								label = chart.renderer.text('', 0, 0).add()
								;(chart as any).centerLabel = label
							}

							label.attr({
								text: approvedPercentageLabel,
								x,
								y,
								align: 'center',
							}).css({
								fontSize: '36px',
								fontWeight: 'bold',
							})
						},
					},
				},
				title: { text: '' },
				legend: {
					align: 'right',
					verticalAlign: 'middle',
					layout: 'vertical',
				},
				series: [{
					type: 'pie',
					name: 'Amostras',
					colorByPoint: true,
					data: [
						{
							name: 'Aprovado',
							y: approved,
							color: ThemeProject.primary100,
						},
						{
							name: 'Reprovação',
							y: rejected,
							color: ThemeProject.primary400,
						},
					],
				}],
				tooltip: {
					formatter: function () {
						return `<b>${this.point.name}</b>: ${this.y}`
					},
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						innerSize: '70%',
						dataLabels: {
							enabled: false,
						},
						showInLegend: true,
					},
				},
				exporting: {
					enabled: true,
				},
			}}
			chartType={'pie'}
		/>
	)
}
